import React from "react";
import { graphql } from "gatsby";
import SEO from "../components/SEO";
import {
  PageSection,
  PageSectionArticle,
  PageSectionWrapper,
  TextEditor,
} from "../components/common";
import { toHTML } from "../utils/helpers";

const GdprPageTemplate = ({ title, gdprData }) => {
  const { heading, body } = gdprData;
  return (
    <>
      <SEO title={title} />
      <PageSectionWrapper bgColor="var(--creamWhite)">
        <PageSection bgColor="var(--creamWhite)">
          <PageSectionArticle>
            <h1>{heading}</h1>
            <TextEditor
              style={{ maxWidth: "900px" }}
              dangerouslySetInnerHTML={{ __html: toHTML(body) }}
            />
          </PageSectionArticle>
        </PageSection>
      </PageSectionWrapper>
    </>
  );
};

const GdprPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <GdprPageTemplate
      title={frontmatter.title}
      gdprData={frontmatter.gdprData}
    />
  );
};

export default GdprPage;

export const pageQuery = graphql`
  query GdprPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        gdprData {
          heading
          body
        }
      }
    }
  }
`;
